import {
  BuildingOffice2Icon,
  ClipboardDocumentCheckIcon,
  ClockIcon,
  CubeIcon,
  DocumentTextIcon,
  ShieldCheckIcon,
  TruckIcon,
  UserGroupIcon,
  WrenchScrewdriverIcon,
} from "@heroicons/react/24/outline";

export const NAV_LINKS = [
  { name: "Funksjoner", href: "#funksjoner" },
  { name: "Moduler", href: "#moduler" },
  { name: "Integrasjoner", href: "#integrasjoner" },
] as const;

export const HERO_STATS = [
  { value: "Modulært", label: "Aktiver det dere trenger" },
  { value: "Én plattform", label: "Prosjekt til faktura" },
  { value: "Flerspråklig", label: "Tilpasset flere markeder og språk" },
] as const;

export const FEATURES = [
  {
    icon: BuildingOffice2Icon,
    title: "Prosjekter og arbeidsordre",
    description:
      "Samle prosjekter, oppgaver, dokumenter og fremdrift. Arbeidsordre fra planlegging til utført jobb.",
  },
  {
    icon: WrenchScrewdriverIcon,
    title: "Service og rapporter",
    description:
      "Serviceavtaler, inspeksjoner og rapporter med bilder, signatur og deling til kunde — også uten innlogging.",
  },
  {
    icon: ClipboardDocumentCheckIcon,
    title: "Kvalitet og avvik",
    description:
      "Sjekklister, avvikshåndtering og oppfølging. Dokumenter det som skjer, når det skjer.",
  },
  {
    icon: ClockIcon,
    title: "Timer og fravær",
    description:
      "Timeregistrering, arbeidstid og fravær i samme system som prosjektene — mindre dobbeltføring.",
  },
  {
    icon: ShieldCheckIcon,
    title: "HMS og KS",
    description:
      "Strukturert HMS/KS-arbeid med dokumenter, hendelser, risiko og revisjon — klart for systematisk forbedring.",
  },
  {
    icon: UserGroupIcon,
    title: "Kunder og tilbud",
    description:
      "Kundekort, kommunikasjon, tilbud og ordre. Alt koblet til prosjekter og leveranser.",
  },
] as const;

export const MODULE_HIGHLIGHTS = [
  "Prosjekter",
  "Service",
  "Kvalitet",
  "Timer",
  "Fravær",
  "Dokumentasjon",
  "Tilbud",
  "Ordre",
  "Lager",
  "Kjørebok",
  "HMS/KS",
  "Journalføring",
  "Mannskapsplanlegging",
  "Nettbutikk",
] as const;

export const INTEGRATIONS = [
  {
    name: "Tripletex",
    description: "Regnskap, faktura og lønn i flyt med prosjekter og timer.",
  },
  {
    name: "Microsoft 365",
    description: "E-post, kalender og innlogging med Entra ID / OAuth.",
  },
  {
    name: "Phonero",
    description: "Telefoni og kommunikasjon koblet til kunder og saker.",
  },
  {
    name: "Automile",
    description: "Kjøretøy og kjørebok integrert med kjøring-modulen.",
  },
] as const;

export const TRUST_POINTS = [
  {
    icon: DocumentTextIcon,
    title: "Dokumentasjon som holder",
    text: "Bilder, PDF-er og vedlegg på prosjekt, rapport, avvik og sak — med versjonering og deling.",
  },
  {
    icon: CubeIcon,
    title: "Skalerer med bedriften",
    text: "Start med det viktigste. Slå på flere moduler når behovet vokser — uten å bytte plattform.",
  },
  {
    icon: TruckIcon,
    title: "For felt og kontor",
    text: "Mobilvennlig arbeidsflate for teknikere, og full oversikt for ledere og administrasjon.",
  },
] as const;
